import {publishEvent} from '../analytics/pub-sub';
import {ANALYTIC_EVENTS} from '../analytics/pub-sub/constants';

const handleLanguageSwitcherEvents = articleId => {
  const languageSwitcherElement = document
    .querySelector(`.layout-content-type-page .js-article-language-switcher[data-id="${articleId}"]`);

  if (languageSwitcherElement) {
    languageSwitcherElement.addEventListener('click', () => {
      publishEvent(ANALYTIC_EVENTS.LANGUAGE_SWITCHER_CLICK_EVENT, {
        language: languageSwitcherElement.dataset.eventLanguage
      });
    });
  }
};

export {handleLanguageSwitcherEvents};
